<template>
  <div>
    <Modal v-model="show" :mask-closable="false" :loading="loading" @on-ok="ok">
      <h3 slot="header" class="modal-header">配置顺序</h3>
       <Form :label-width="100" :model="formData" :rules="formRules" ref="formData">
         <FormItem label="顺序" prop="configOrder">
          <Input class="input-width3" v-model="formData.configOrder" />
        </FormItem>
       </Form>
    </Modal>

  </div>
</template>

<script>
  import {houseTypeConfig} from "api/houseTypeConfig";
  
  export default {
    name: "updateOrder",
    props:{
      n:{
        type:Number,
        default:0
      },
      fid:{
        type:String,
        default:0
      },
      order:{
        type:Number,
        default:0
      }
    },
    watch:{
      n() {
        this.show = true
      },
      order(val) {
        this.formData.configOrder = val
      }
    },
    data(){
      const validateNum = (rules,value,callback) => {
        const pattern = /^(?:[1-9][0-9]*\.[0-9]+|0\.(?!0+$)[0-9]+|[1-9]+\d*)$/
        if(value !=='' && !pattern.test(value)){
          callback(new Error('请输入大于0的数字'));
        } 
        callback();
      }
      return {
        
        show:false,
        loading:true,
       
        formData:{
          configOrder:''
        },
        formRules: {
          configOrder: [
            {required: true,trigger: 'blur', validator: validateNum}
          ]
        }
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      // setDefault(){
      //   this.status=this.radioList[0].value
      // },
      ok(){
        let data = {
          fid: this.fid,
          configOrder:''
        }
        
        this.$refs['formData'].validate( bool => {
          if(bool){
            let order = this.formData.configOrder
            if(!order){
              this.$Message.error('请先添加排序')
              this.changeLoading()
              return
            }
            data.configOrder = order
            houseTypeConfig(data).then(res=>{
              this.$Message.success('顺序配置成功')
              this.changeLoading()
              this.$emit('refresh')
              this.show = false    
            })
          }else{
          this.changeLoading()
          return
          }
        });
      }
    }
  }
</script>

<style scoped>
 .input-width3 {
    width: 150px;
  }
</style>
